import React, { FunctionComponent } from 'react';
import { DefaultSeo } from 'next-seo';
import { Router } from 'next/router';
import { useLocalization } from '@bumble/localization/components';
import { SupportedLanguage } from 'lib/lexemes/supported-languages';

const APP_NAME = 'Bumble For Friends';

type PageSeoProps = {
    lang: SupportedLanguage;
    router: Router;
};

const PageSeo: FunctionComponent<PageSeoProps> = ({ lang, router }) => {
    const Localization = useLocalization();

    /* Use appType to switch between different SEO tags */
    return (
        <DefaultSeo
            title={Localization.get('bumblesite@bff.landing.seo.title')}
            languageAlternates={getLanguageAlternates(router)}
            canonical={getCanonical(router)}
            facebook={{
                appId: 'bumble-join-hives',
            }}
            additionalMetaTags={[
                {
                    name: 'apple-itunes-app',
                    content: 'app-id=6444040977',
                },
                {
                    property: 'p:domain_verify',
                    content: '26cd87d4b7db08a05bdfa2219d3671b6',
                },
                {
                    property: 'referrer',
                    content: 'origin-when-cross-origin',
                },
                {
                    property: 'twitter:app:name:iphone',
                    content: APP_NAME,
                },
                {
                    property: 'twitter:app:id:iphone',
                    content: '6444040977',
                },
            ]}
            openGraph={{
                type: 'website',
                locale: lang,
                url: getCanonical(router),
                site_name: APP_NAME,
                title: Localization.get('bumblesite@join_plans.link_preview.header'),
                description: Localization.get('bumblesite@join_plans.link_preview.body'),
                images: [
                    {
                        url: 'https://bumble.com/bff/assets/social-sharing.jpg',
                        alt: APP_NAME,
                        width: 1200,
                        height: 630,
                    },
                ],
            }}
            twitter={{
                handle: '@bumble',
                cardType: 'summary_large_image',
                site: '@bumble',
            }}
        />
    );
};

/**
 * Returns "alternate" languages for SEO
 */
function getLanguageAlternates(_router: Router) {
    return [];
}

function getCanonical(_router: Router) {
    return '';
}

export default PageSeo;
